import * as userSoleProprietorshipApi from '../../api/userSoleProprietorship'
import _ from 'lodash'

async function getUserSoleProprietorships({ commit }, getUserCompaniesData) {
  const userSoleProprietorships = await userSoleProprietorshipApi.getUserSoleProprietorships(getUserCompaniesData)
  commit('setUserSoleProprietorships', userSoleProprietorships)
}

async function getUserSoleProprietorship({ commit }, getUserSoleProprietorshipData) {
  const userSoleProprietorship = await userSoleProprietorshipApi.getUserSoleProprietorship(
    getUserSoleProprietorshipData
  )
  commit('setSelectedUserSoleProprietorship', userSoleProprietorship)
}

async function createUserSoleProprietorship({ dispatch }, createUserSoleProprietorshipData) {
  await userSoleProprietorshipApi.createUserSoleProprietorship(createUserSoleProprietorshipData)
  dispatch('getUserSoleProprietorships', {})
  //dispatch('notify', { newNotification: { type: 'success', message: 'Cég hozzárendelés létrehozva!' } })
}

// eslint-disable-next-line no-unused-vars
async function patchUserSoleProprietorship({ dispatch }, patchUserSoleProprietorshipData) {
  await userSoleProprietorshipApi.patchUserSoleProprietorship(patchUserSoleProprietorshipData)
  //dispatch('notify', { newNotification: { type: 'success', message: 'Cég hozzárendelés frissítve.' } })
}

// eslint-disable-next-line no-unused-vars
async function deleteUserSoleProprietorship({ dispatch }, deleteUserSoleProprietorshipData) {
  await userSoleProprietorshipApi.deleteUserSoleProprietorship(deleteUserSoleProprietorshipData)
  //dispatch('notify', { newNotification: { type: 'success', message: 'Cég hozzárendelés törölve!' } })
}

function setUserSoleProprietorships(state, userSoleProprietorships) {
  state.userSoleProprietorships = userSoleProprietorships
}

function setSelectedUserSoleProprietorship(state, selectedUserSoleProprietorship) {
  state.selectedUserSoleProprietorship = selectedUserSoleProprietorship
}

const userSoleProprietorshipStore = {
  state: { userSoleProprietorships: [], selectedUserSoleProprietorship: null },
  actions: {
    getUserSoleProprietorships,
    getUserSoleProprietorship,
    createUserSoleProprietorship,
    patchUserSoleProprietorship,
    deleteUserSoleProprietorship
  },
  mutations: {
    setUserSoleProprietorships,
    setSelectedUserSoleProprietorship
  },
  getters: {
    userSoleProprietorshipOptions: state => {
      const userSoleProprietorshipOptions = state.userSoleProprietorships.map(userSoleProprietorship => ({
        text: userSoleProprietorship.soleProprietorshipData.name,
        value: userSoleProprietorship
      }))
      return userSoleProprietorshipOptions
    },
    selectedUserSoleProprietorship: state => {
      return state.selectedUserSoleProprietorship
    },
    selectedUserSoleProprietorshipApplications: state => {
      return _.sortBy(
        state.selectedUserSoleProprietorship?.competitions.filter(competition => competition.type === 'APPLICATION'),
        a => a.name.toLowerCase()
      )
    },
    selectedUserSoleProprietorshipCredits: state => {
      return _.sortBy(
        state.selectedUserSoleProprietorship?.competitions.filter(competition => competition.type === 'CREDIT'),
        a => a.name.toLowerCase()
      )
    },
    selectedUserSoleProprietorshipCapitalProducts: state => {
      return _.sortBy(
        state.selectedUserSoleProprietorship?.competitions.filter(
          competition => competition.type === 'CAPITAL_PRODUCT'
        ),
        a => a.name.toLowerCase()
      )
    },
    selectedUserSoleProprietorshipGuarantees: state => {
      return _.sortBy(
        state.selectedUserSoleProprietorship?.competitions.filter(competition => competition.type === 'GUARANTEE'),
        a => a.name.toLowerCase()
      )
    },
    userSoleProprietorships: state => {
      return state.userSoleProprietorships
    }
  }
}

export default userSoleProprietorshipStore
